import Cookies from "js-cookie";

// Estado padrão com 6 cores customizáveis
const defaultThemeState = {
  darkMode: false,
  colors: {
    primary: "#007bff",      // Azul primário
    secondary: "#6c757d",    // Cinza secundário
    accent: "#ff6b6b",       // Vermelho accent
    success: "#28a745",      // Verde success
    warning: "#ffc107",      // Amarelo warning
    danger: "#dc3545",       // Vermelho danger
  }
};

// Carregar cores customizadas do localStorage se existirem
const getSavedTheme = () => {
  try {
    const saved = localStorage.getItem("appThemeColors");
    if (saved) {
      const parsed = JSON.parse(saved);
      // Garantir que o darkMode seja sempre um booleano
      if (typeof parsed === 'object' && parsed !== null) {
        return {
          darkMode: Boolean(parsed.darkMode),
          colors: parsed.colors || defaultThemeState.colors
        };
      }
    }
    
    // Migrar do cookie antigo se existir
    const oldDarkThemeCookie = Cookies.get("darkTheme");
    if (oldDarkThemeCookie) {
      try {
        const darkModeValue = JSON.parse(oldDarkThemeCookie);
        // Remover cookie antigo
        Cookies.remove("darkTheme");
        return {
          ...defaultThemeState,
          darkMode: Boolean(darkModeValue)
        };
      } catch (e) {
        console.error("Erro ao migrar cookie antigo:", e);
      }
    }
  } catch (error) {
    console.error("Erro ao carregar tema salvo:", error);
  }
  return defaultThemeState;
};

export function themeReducer(state = getSavedTheme(), action) {
  let newState;

  switch (action.type) {
    case "DARK":
      newState = { ...state, darkMode: true };
      break;
    case "LIGHT":
      newState = { ...state, darkMode: false };
      break;
    case "SET_THEME_COLORS":
      newState = {
        ...state,
        colors: {
          ...state.colors,
          ...action.payload
        }
      };
      break;
    case "RESET_THEME_COLORS":
      newState = { ...state, colors: defaultThemeState.colors };
      break;
    case "SET_SINGLE_COLOR":
      newState = {
        ...state,
        colors: {
          ...state.colors,
          [action.payload.colorKey]: action.payload.value
        }
      };
      break;
    case "TOGGLE_DARK_MODE":
      newState = { ...state, darkMode: !state.darkMode };
      console.log("🌓 Toggle Dark Mode:", state.darkMode, "→", newState.darkMode);
      break;
    default:
      return state;
  }

  // Salvar no localStorage
  try {
    localStorage.setItem("appThemeColors", JSON.stringify(newState));
    console.log("💾 Tema salvo:", newState);
  } catch (error) {
    console.error("Erro ao salvar tema:", error);
  }

  return newState;
}
